<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Mandats ouverts pour lesquels il n'y a pas de débiteur"
          class="bg-light shadow"
          title-tag="h6"
        >
          <div class="card-body" v-if="loaded" v-html="vierges"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageWarrantsWithoutDebtor",
  components: {},
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats vierges",
          active: true,
        },
      ],
      sms: {},
      order: 'ID',
      sort: 'ascending',
      busy: false,
      loaded: false,
    };
  },
  created() {
    this.load();
    document.addEventListener("click", (e) => {
      if (e.target) {
        switch(e.target.id) {
          case 'sortByVendeur':
            this.order = 'vendeur';
            this.sort = this.sort == 'ascending' ? 'descending' : 'ascending';
            this.load();
            break;
          case 'sortByDateCreation':
            this.order = 'date_creation';
            this.sort = this.sort == 'ascending' ? 'descending' : 'ascending';
            this.load();
            break;
          case 'sortByContact':
            this.order = 'contact';
            this.sort = this.sort == 'ascending' ? 'descending' : 'ascending';
            this.load();
            break;
          case 'sortByID':
            this.order = 'ID';
            this.sort = this.sort == 'ascending' ? 'descending' : 'ascending';
            this.load();
            break;
        }
      }
    });
  },
  methods: {
    load() {
      this.busy = true;
      gestion.vierges(this.order, this.sort).then((response) => {
        this.vierges = response.data;
        this.busy = false;
        this.loaded = true;
      });
    },
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>